module.exports = __webpack_public_path__ + "img/4.f806d0b5.jpg";